import ExpandableSidebar from 'components/organisms/Layouts/expandableSidebar'
import * as React from 'react'
import { BREAKPOINT_DESKTOP, COLORS, FOOTER_HEIGHT, MOBILE_HEADER_HEIGHT } from 'static/constants'
import { IUser } from 'static/interfaces'
import styled from 'styled-components'
import { getRoleLabel, isShowSidebarFromRoleLabel } from 'utils/layout'
import { ExpandableBody } from 'components/organisms/Layouts/expandableBody'

interface IProps {
  children: React.ReactElement
  user: IUser
  showSidebar?: boolean
  className?: string
  disableMaxWidth?: boolean
}

/**
 * 全画面モードがあるバージョンのSidebarLayout
 * 必要に応じて置き換える
 */
const ExpandableLayout: React.VFC<IProps> = ({
  children,
  user,
  showSidebar = false,
  className,
  disableMaxWidth = false,
}) => {
  const urlParams = new URLSearchParams(window.location.search)
  const initExpanded = urlParams.get('expanded') === 'true'

  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [expanded, setExpanded] = React.useState<boolean>(initExpanded)
  const childrenWithProps = React.cloneElement(children, user)

  // Post special case (only show sidebar for own posts)
  const approvedUser = (user?.guide && user?.guide_approved) || user?.agent

  const toggleExpanded = () => {
    setExpanded(old => !old)
  }

  React.useEffect(() => {
    const url = new URL(window.location.href)
    const currentUrlParams = url.searchParams
    if (expanded) {
      currentUrlParams.append('expanded', String(expanded))
    } else {
      currentUrlParams.delete('expanded')
    }
    url.search = currentUrlParams.toString()
    const newUrl = url.toString()
    window.history.replaceState(
      { ...window.history.state, as: newUrl, url: newUrl },
      undefined,
      newUrl
    )
  }, [expanded])

  const roleLabel = getRoleLabel(user)

  return isShowSidebarFromRoleLabel(roleLabel) || showSidebar ? (
    <Base>
      <ExpandableSidebar
        open={isOpen}
        roleLabel={roleLabel}
        approvedUser={approvedUser}
        expanded={expanded}
      />

      <ExpandableBody
        className={className}
        childrenWithProps={childrenWithProps}
        disableMaxWidth={disableMaxWidth}
        expanded={expanded}
        toggleExpanded={toggleExpanded}
      />
    </Base>
  ) : (
    <>{childrenWithProps}</>
  )
}

const Base = styled.div`
  width: 100%;
  display: flex;
  background: ${COLORS.background};
  min-height: calc(100vh - ${MOBILE_HEADER_HEIGHT + FOOTER_HEIGHT}px);
  @media (max-width: ${BREAKPOINT_DESKTOP}px) {
    min-height: calc(100vh - ${FOOTER_HEIGHT}px);
  }
  .burgerWrapper {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2001;
    @media (max-width: ${BREAKPOINT_DESKTOP}px) {
      display: block;
    }
  }
`

export default ExpandableLayout
